import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=5b7df5fa&scoped=true&"
import script from "./FormLayout.vue?vue&type=script&lang=js&"
export * from "./FormLayout.vue?vue&type=script&lang=js&"
import style0 from "./FormLayout.vue?vue&type=style&index=0&id=5b7df5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7df5fa",
  null
  
)

export default component.exports